import { graphql, useStaticQuery } from 'gatsby';

export type SiteConfigNavCta = {
  text: string;
  link: string;
};

/**
 * TEMPORARY (DCXC-257): delete when curology.com moves to the Shopify nav.
 *
 * The CTA Button picked in Site Config's "Nav CTA" field, sourced once per
 * build by `sourceNodes` in gatsby-node.ts. The link is already formatted.
 * Undefined when the field is empty.
 *
 * This file is .tsx on purpose. webpack.config.js sends .ts files through a
 * plain babel-loader that skips Gatsby's plugin for compiling `graphql` tags
 * away, so a static query in a .ts file fails in the browser.
 */
export const useSiteConfigNavCta = (): SiteConfigNavCta | undefined => {
  const { siteConfigNavCta } = useStaticQuery<{
    siteConfigNavCta: SiteConfigNavCta | null;
  }>(graphql`
    query SiteConfigNavCta {
      siteConfigNavCta {
        text
        link
      }
    }
  `);

  return siteConfigNavCta ?? undefined;
};
